import get from "lodash/get";

/* eslint no-undef: 0 */
export default class Environment {
  static get isProduction() {
    return process.env.NODE_ENV === "production";
  }

  static get isDevelopment() {
    return process.env.NODE_ENV === "development";
  }

  static get environment() {
    return process.env.NODE_ENV;
  }
}

export function getDeploymentEnvironment() {
  return get(window, "Session.DEPLOYMENT_ENVIRONMENT", "production");
}
